export default function joinTextValues(
    textValues: (string | undefined | null)[],
    joinWith = ' ',
): string {
    const values = textValues.filter((v) => !!v)

    return values.join(joinWith)
}
